<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-01"><span><i>This Is a True Story</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter01.vue?4bb9cc3b